"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var clsx_1 = require("clsx");
var carTitleStyles_1 = require("./carTitleStyles");
var CarTitle = function (_a) {
    var vehicleDisplayName = _a.vehicleDisplayName;
    var style = carTitleStyles_1.default();
    var showSpecificationColorName = core_1.useTheme().checkoutLite.summary.showSpecificationColorName;
    var vehicleName = vehicleDisplayName.split(' ');
    var lastVehicleName = vehicleName.slice(1).join(' ');
    return (<core_1.Typography variant="subtitle1" className={style.titleWrapper} data-test="summary:vehicle:car_title">
      {showSpecificationColorName && (<core_1.Typography variant="h4" className={clsx_1.default([
        style.title,
        style.specificationTitle,
        showSpecificationColorName && vehicleName.length > 1 && style.customColorName,
    ])} component="span" data-test="summary:vehicle:car_title_first_vehicle_name">
          {vehicleName[0]}
        </core_1.Typography>)}
      <core_1.Typography variant="h4" className={style.title} component="span" data-test="summary:vehicle:car_title_vehicle_name">
        {showSpecificationColorName ? lastVehicleName : vehicleDisplayName}
      </core_1.Typography>
    </core_1.Typography>);
};
exports.default = CarTitle;
